import { Navigate, Outlet, useLocation } from 'react-router';
import { useAuthStore } from '@/entities/session/model/authStore';
import { useLoginGate } from './login/gateStore';

export function RequireAuth() {
  const status = useAuthStore((s) => s.status);
  const user = useAuthStore((s) => s.user);
  const location = useLocation();
  if (status !== 'authenticated' || !user)
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  if (user.requiresPasswordChange && location.pathname !== '/change-password')
    return <Navigate to="/change-password" replace />;
  return <Outlet />;
}

export function RequireSysRole() {
  const user = useAuthStore((s) => s.user);
  if (!user?.isSysRol) return <Navigate to="/" replace />;
  return <Outlet />;
}

export function RequireWebLicense() {
  const user = useAuthStore((s) => s.user);
  if (user && user.hasNodeLicense && !user.hasWebLicense) return <Navigate to="/node" replace />;
  return <Outlet />;
}

export function AnonymousOnly() {
  const status = useAuthStore((s) => s.status);
  // Giriş akışı sürerken (lisans kapısı) yönlendirme bekletilir: `login()` çözülür
  // çözülmez durum "authenticated" oluyor ve uyarı hiç görünmeden geçiliyordu.
  const gatePending = useLoginGate((s) => s.pending);
  if (status === 'authenticated' && !gatePending) return <Navigate to="/" replace />;
  return <Outlet />;
}
